import { FuseRouteItemType } from '@fuse/utils/FuseUtils';
import FeaturedView from './FeaturedView';

const route: FuseRouteItemType = {
	path: 'catalog/featured',
	element: <FeaturedView />
};

export default route;
